import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    data: [],
    loading: false,
    error: false,
    selectedRows: [],
    // Databricks job state
    jobLoading: false,
    jobStatus: null,
    jobRunId: null,
    jobId: null,
    jobNumberInJob: null,
    jobErrorMessage: null
}

const reportsSecondTableSlice = createSlice({
    name: 'reportsSecondTable',
    initialState,
    reducers: {
        setSelectedRows: (state, action) => {
            state.selectedRows = action.payload;
        },
        clearSecondTableData: (state) => {
            state.data = [];
            state.selectedRows = [];
            state.error = false;
        },
        resetError: (state) => {
            state.error = false;
        }
    },
});

export const { setSelectedRows, clearSecondTableData, resetError } = reportsSecondTableSlice.actions;

export default reportsSecondTableSlice.reducer;
